<!-- 应用列表 -->
<template>
  <div class="applist">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>
    <div class="barPath width">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/appmarket' }">应用市场</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/appList' }">应用列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 快速查找 -->
    <div class="fastSoo width">
      <div class="fastSooTitle">
        <div class="sooType clearfix">
          <div class="tt">类型：</div>
          <span
            :class="i==index?'active':''"
            v-for="(item,i) in datatwo"
            :key="i"
            :index="i"
            @click="oneTitle(item.id,i)"
          >{{item.name}}</span>
        </div>
        <div class="genre clearfix">
          <div class="tt">类别：</div>
          <span
            :class="item.id==index1?'active':''"
            v-for="(item,i) in datathree"
            :key="i"
            :index1="i"
            @click="twoTitle(item.id,i)"
          >{{item.name}}</span>
        </div>
        <div class="way clearfix">
          <div class="tt">交付方式：</div>
          <span
            :class="i==index2?'active':''"
            v-for="(item,i) in datafour"
            :key="i"
            :index2="i"
            @click="threeTitle(item.id,i)"
          >{{item.name}}</span>
        </div>
        <div class="sooInput">
          <el-input placeholder="请输入内容" v-model="soo.names">
            <template slot="append">
              <el-button type="primary" @click="sousuo()">搜索</el-button>
            </template>
          </el-input>
        </div>
      </div>
      <div class="sortList clearfix">
        <span>排序：</span>
        <div
          class="sortItem"
          @click="defaultSort(1)"
          :class="(countIndex!=0||priceIndex!=0)?'':'act'"
        >默认</div>
        <div class="sortItem">
          价格
          <i
            class="el-icon-caret-top el-icon--top"
            @click="priceSort(1)"
            :class="priceIndex==1?'act':''"
          ></i>
          <i
            class="el-icon-caret-bottom el-icon--bottom"
            @click="priceSort(2)"
            :class="priceIndex==2?'act':''"
          ></i>
        </div>
        <div class="sortItem">
          点击数量
          <i class="el-icon-caret-top" @click="countSort(1)" :class="countIndex==1?'act':''"></i>
          <i class="el-icon-caret-bottom" @click="countSort(2)" :class="countIndex==2?'act':''"></i>
        </div>
      </div>
      <div class="appItemList">
        <div class="appItem" v-for="(item,i) in dataone.items" :key="i">
          <div class="appItemImg">
            <img :src="item.cover_photo" alt srcset />
          </div>
          <div class="appItemCon">
            <div class="title">{{item.name}}</div>
            <div class="pp">
              <p>基于洲工业互联网平台，形成动态非配合式人脸识别系统解决方案，方案应用于区域、楼宇等场所，对场所进出人......</p>
              <span>交付方式：{{item.typename}}</span>
            </div>
            <span class="attestation">{{item.is_renzhen==1?'已验证':'未验证'}}</span>
            <span class="supplier">服务商：{{item.pname}}</span>
            <span class="browse">浏览次数：{{item.click_count}}次</span>
          </div>
          <div class="appDetails">
            <el-button type="primary" @click="goto(item.id)">查看详情</el-button>
          </div>
        </div>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="soo.pages"
          :page-size="10"
          layout="total,prev, pager, next, jumper"
          :total="dataone.total"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, Footer },
  props: {},
  data() {
    return {
      topImg: {
        title: '',
        bgImg: require('../assets/images/u1.png'),
        content: '',
        bl: false,
      },
      soo: {
        names: '',
        ids: 0,
        twoid: 0,
        paytype: 0,
        price: 0,
        clickcount: 0,
        pages: 1,
        use_count: '',
      },
      dataone: [],
      datatwo: [],
      datathree: [],
      datafour: [],
      index: 0,
      index1: 0,
      index2: 0,
      priceIndex: 0,
      countIndex: 0,
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {
    // if (!this.$route.params.paramsData && !sessionStorage.getItem('soo')) {
    //   this.$router.push('/appmarket')
    //   return
    // }
    if (this.$route.params.paramsData) {
      this.soo.names = this.$route.params.paramsData.names
      this.soo.ids = this.$route.params.paramsData.ids
      this.soo.twoid = this.$route.params.paramsData.items
      this.index = this.soo.ids
      this.index1 = this.soo.twoid
      // sessionStorage.setItem('soo', JSON.stringify(this.soo))
    }
    // else {
    //   this.soo = JSON.parse(sessionStorage.getItem('soo'))
    // }
    this.getListData()
  },
  mounted() {},
  methods: {
    async getListData() {
      const res = await this.$http.post('/getAllapp', this.soo)
      this.dataone = res.data.data.dataone
      this.datatwo = res.data.data.datatwo
      this.datathree = res.data.data.datathree
      this.datafour = res.data.data.datafour
    },
    async oneTitle(i, j) {
      this.index = j
      this.soo.ids = i
      this.getListData()
    },
    async twoTitle(i, j) {
      this.index1 = i
      this.soo.twoid = i
      this.getListData()
    },
    async threeTitle(i, j) {
      this.index2 = j
      this.soo.paytype = i
      this.getListData()
    },
    async sousuo(i, j) {
      this.getListData()
    },
    async priceSort(i) {
      this.soo.price = i
      this.soo.clickcount = 0
      this.soo.use_count = 0
      this.priceIndex = i
      this.countIndex = 0
      this.getListData()
    },
    async countSort(i) {
      this.soo.clickcount = i
      this.soo.price = 0
      this.soo.use_count = 0
      this.countIndex = i
      this.priceIndex = 0
      this.getListData()
    },
    async defaultSort(i) {
      this.soo.use_count = i
      this.soo.clickcount = 0
      this.soo.price = 0
      this.countIndex = 0
      this.priceIndex = 0
      this.getListData()
    },
    goto(i) {
      this.$router.push({
        name: 'applistdetails',
        params: {
          //params 传递参数
          ids: i,
        },
      })
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.soo.pages = val
      this.getListData()
    },
  },
}
</script>

<style lang="less" scoped>
.barPath {
  height: 48px;
  line-height: 48px;
  background-color: #fff;
  padding-left: 20px;
  box-sizing: border-box;
  margin-bottom: 10px;
  .el-breadcrumb {
    line-height: 48px;
    font-size: 16px !important;
  }
}
.fastSoo {
  .fastSooTitle {
    background-color: #fff;
    padding: 10px;
    margin-bottom: 10px;
    .sooType,
    .genre,
    .way {
      margin: 10px 0;
      .tt {
        float: left;
        max-width: 80px;
      }
      span {
        float: left;
        padding: 0 20px;
        text-align: center;
        cursor: pointer;
      }
      span:hover {
        color: #0079fe;
      }
      .active {
        color: #0079fe;
      }
    }
    .genre {
      .tt {
        line-height: 30px;
      }
      span {
        line-height: 30px;
      }
    }
    .sooInput {
      width: 600px;
      margin: 20px 0;
    }
  }
  .sortList {
    height: 48px;
    line-height: 48px;
    background-color: #fff;
    padding-left: 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    span {
      float: left;
      max-width: 60px;
    }
    .sortItem {
      position: relative;
      float: left;
      padding: 0 20px;
      text-align: center;
      cursor: pointer;
      .el-icon-caret-top {
        position: absolute;
        right: 0;
        top: 11px;
        font-size: 18px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: 0;
        bottom: 11px;
        font-size: 18px;
      }
      .el-icon-caret-top:hover,
      .el-icon-caret-bottom:hover {
        color: #0079fe;
      }
    }
    .act {
      color: #0079fe;
    }
  }
  .appItemList {
    .appItem {
      display: flex;
      background-color: #fff;
      margin-bottom: 10px;
      .appItemImg {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 100%;
          max-height: 160px;
          padding: 20px 10px 20px 10px;
          box-sizing: border-box;
        }
      }
      .appItemCon {
        flex: 5;
        .title {
          font-weight: 700;
          font-size: 16px;
          margin-top: 15px;
        }
        .pp {
          display: flex;
          justify-content: space-between;
          align-items: center;
          p {
            flex: 7;
          }
          span {
            flex: 1;
          }
        }
        .attestation {
          display: block;
          color: #16c31d;
        }
        .supplier {
          display: block;
          margin: 10px 0;
        }
        .browse {
          display: block;
          margin-bottom: 10px;
        }
      }
      .appDetails {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
.el-pagination {
  text-align: center;
  padding: 20px 0;
  background-color: #fff;
}
</style>
